"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListViewProductCard = ListViewProductCard;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fusePrice = require("@tvg/fuse-price");
var _fuseProductImage = _interopRequireDefault(require("@tvg/fuse-product-image"));
var _config = _interopRequireDefault(require("./config"));
var _styledListViewProductCard = require("./styled-list-view-product-card");
var _excluded = ["productUrl", "brand", "title", "image", "price", "sfl", "dataTestId", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useMemo = _react["default"].useMemo,
  useCallback = _react["default"].useCallback,
  useState = _react["default"].useState;
var propTypes = {
  productUrl: _propTypes["default"].string,
  brand: _propTypes["default"].string,
  title: _propTypes["default"].string,
  image: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    altText: _propTypes["default"].string,
    isAltReal: _propTypes["default"].bool
  }),
  price: _propTypes["default"].shape({
    current: _propTypes["default"].number,
    showCurrentPriceFrom: _propTypes["default"].bool,
    previous: _propTypes["default"].number,
    showPreviousPriceFrom: _propTypes["default"].bool,
    saving: _propTypes["default"].number,
    showSave: _propTypes["default"].bool,
    isEuro: _propTypes["default"].bool
  }),
  sfl: _propTypes["default"].shape({
    isSaved: _propTypes["default"].bool,
    saveCallback: _propTypes["default"].func
  }),
  dataTestId: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var defaultProps = {
  productUrl: "#",
  brand: "",
  title: "",
  image: {
    url: undefined,
    altText: undefined,
    isAltReal: false
  },
  price: {
    current: 0,
    showCurrentPriceFrom: false,
    previous: 0,
    showPreviousPriceFrom: false,
    saving: 0,
    showSave: true,
    isEuro: false
  },
  sfl: {
    saveCallback: null,
    isSaved: false
  },
  dataTestId: null,
  className: undefined
};
var isAltExists = function isAltExists(text) {
  return (typeof text === 'string' || text instanceof String) && text.length > 1;
};
function ListViewProductCard(_ref) {
  var productUrl = _ref.productUrl,
    brand = _ref.brand,
    title = _ref.title,
    image = _ref.image,
    price = _ref.price,
    sfl = _ref.sfl,
    dataTestId = _ref.dataTestId,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(sfl === null || sfl === void 0 ? void 0 : sfl.isSaved),
    _useState2 = _slicedToArray(_useState, 2),
    isSavePressed = _useState2[0],
    setSavePressed = _useState2[1];
  var imgAlt = !isAltExists(image === null || image === void 0 ? void 0 : image.altText) ? "Missing image for: ".concat(title) : image === null || image === void 0 ? void 0 : image.altText;
  var textSize = useMemo(function () {
    return {
      xxs: 'm1',
      m: 'm1',
      l: '1'
    };
  }, []);
  var handleSaveForLater = useCallback(function (e, _, newState) {
    e.preventDefault();
    setSavePressed(newState);
    sfl === null || sfl === void 0 || sfl.saveCallback(newState);
  }, [sfl === null || sfl === void 0 ? void 0 : sfl.saveCallback]);
  return /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.CardContainer, _extends({
    className: className,
    "data-testid": dataTestId || 'fuse-list-view-product-card-data-testid'
  }, props), /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.StyledProductcard, {
    href: productUrl
  }, /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.ImageWrapper, null, /*#__PURE__*/_react["default"].createElement(_fuseProductImage["default"], {
    alt: imgAlt,
    src: image === null || image === void 0 ? void 0 : image.url,
    isAltReal: image === null || image === void 0 ? void 0 : image.isAltReal,
    sources: _config["default"]
  })), /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.ProductDetails, null, /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.BrandContainer, {
    type: "paragraph",
    size: "m1",
    tag: "span"
  }, brand), /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.TitleContainer, {
    type: "heading",
    size: textSize,
    tag: "h3"
  }, title), /*#__PURE__*/_react["default"].createElement(_fusePrice.Price, {
    headingTag: "h4",
    isEuro: price === null || price === void 0 ? void 0 : price.isEuro,
    prevPrice: price === null || price === void 0 ? void 0 : price.previous,
    price: price === null || price === void 0 ? void 0 : price.current,
    saving: price === null || price === void 0 ? void 0 : price.saving,
    showCurrentFrom: price === null || price === void 0 ? void 0 : price.showCurrentPriceFrom,
    showPreviousFrom: price === null || price === void 0 ? void 0 : price.showPreviousPriceFrom,
    showSave: price === null || price === void 0 ? void 0 : price.showSave,
    size: "xs",
    className: "fuse-list-view-product-card__price",
    "data-testid": "list-view-product-card__price"
  })), /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.PlaceForSFL, null)), (sfl === null || sfl === void 0 ? void 0 : sfl.saveCallback) && typeof (sfl === null || sfl === void 0 ? void 0 : sfl.saveCallback) === 'function' && /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.StyledSaveForLater, {
    isSaved: sfl === null || sfl === void 0 ? void 0 : sfl.isSaved,
    clickCallback: handleSaveForLater,
    showLabel: false,
    "aria-pressed": isSavePressed,
    saveLabel: "Save for later ".concat(brand, " ").concat(title),
    savedLabel: "Saved ".concat(brand, " ").concat(title),
    iconSize: "small"
  }));
}
ListViewProductCard.propTypes = propTypes;
ListViewProductCard.defaultProps = defaultProps;
var _default = exports["default"] = ListViewProductCard;